import React, { useState, useEffect } from "react";
import { taskAssign } from "../../config/images";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Button } from "../../components/Button/button";
import { Box, Tabs, Tab, Typography, Dialog, DialogContent, TextField, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import PersonalDetails from "./PersonalDetails";
import LocationDetails from "./LocationDetails";
import FarmingDetails from "./FarmingDetails";
import FarmOwnershipDetails from "./FarmOwnershipDetails";
import AccessToFinance from "./AccessToFinance";
import translations from "../../config/language";
import { getFarmerDetails, updateFarmerStatus } from "../../config/services";
import { notifyError, notifySuccess } from "../../config/ToastMessage";
import { useSelector } from "react-redux";

const PreviewFarmersDetails = ({ galleryIsOpen, setGalleryIsOpen }) => {
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const handleBackClick = () => {
    if (location.state?.from === "Report submission") {
      navigate(-1);
    } else {
      const currentPage = new URLSearchParams(window.location.search).get('page') || 1;
      navigate(`/farmer?page=${currentPage}`);
    }
  };

  const [selectedFarmer, setSelectedFarmer] = useState([]);
  const [isRejectOpen, setIsRejectOpen] = useState(false);

  const { module_access } = useSelector((state) => state.userState)
  const isAccess = module_access?.find((module) =>
    module.module_name === "Farmers" && module.is_editor === true
  ) ? true : false;
  const fetchData = async () => {
    try {
      const resp = await getFarmerDetails(params.id);
      if (resp.data.success === true) {
        setSelectedFarmer(resp.data.payload);
      }
    } catch (error) {
      console.log("error", error);
      notifyError(error.data.response.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const language = process.env.REACT_APP_LANGUAGE;

  const [selectedFarmerDetails, setSelectedFarmerDetails] = useState();
  const [rejectDescription, setRejectDescription] = useState("");
  const [loading, setLoading] = useState(false);

  const handleRejectClose = () => {
    setIsRejectOpen(false);
    setSelectedFarmerDetails();
    setRejectDescription("");
  }

  const handleRejectFarmer = async () => {
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    if (!selectedFarmerDetails) {
      notifyError(translations[language].pleaseSelectReasonForRejection);
      return true;
    }
    const data = {
      farmer_id: params.id,
      status: 11, // reject status
      reject_reason: selectedFarmerDetails,
      comment: rejectDescription,

    }
    try {
      setLoading(true);
      const resp = await updateFarmerStatus(data);
      if (resp.data.success == true) {
        notifySuccess(resp.data.message);
        setIsRejectOpen(false);
        setTimeout(() => {
          setLoading(false);
          navigate("/farmer");
        }, 2000);
      }

    } catch (error) {
      console.log("error", error);
      notifyError(error.message);
      setIsRejectOpen(false);
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }

  };

  const handleApprovedFarmer = async () => {
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    const data = {
      farmer_id: params.id,
      status: 10, // approve status
    }
    try {
      setLoading(true);
      const resp = await updateFarmerStatus(data);
      if (resp.data.success == true) {
        notifySuccess(resp.data.message);
        setTimeout(() => {
          setLoading(false);
          navigate("/farmer");
        }, 2000);
      }

    } catch (error) {
      console.log("error", error);
      notifyError(error.data.response.message);
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }
  };
  return (
    <>
      {/* <Grid container spacing={2}>
        <Grid item xs={12}> */}
      <Box className="task-assign-box">
        <Box className="farmer-header">
          <Box className="d-flex justify-content-between" style={{ flexWrap: "wrap" }}>
            <Box className="d-flex p-3 gap-3 img-box">
              <img
                src={taskAssign.backArrow}
                alt=""
                style={{ height: "44px", width: "44px", cursor: "pointer" }}
                onClick={() => handleBackClick()}
              />
              <img src={taskAssign.union} alt="" />
              <Typography variant="h6" gutterBottom>
                {translations[language].farmersDetailsView}
              </Typography>
            </Box>
            <Box className="edit-profile">

              <button
                title="Reject"
                classname={"border-btn"}
                style={{
                  backgroundColor: "#fff", color: "#31A05F",
                  border: "1px solid #31A05F",
                  borderRadius: "6px", padding: "9px 22px"
                }}
                onClick={() => {
                  if (!isAccess) {
                    notifyError(translations[language].youDontHaveAccess);
                    return;
                  }
                  setIsRejectOpen(true);
                }}
                disabled={activeTab !== 4}
              >{translations[language].reject} </button>
              <Button
                title={translations[language].approved}
                classname={"custom-button"}
                activeTab={activeTab != 4}
                onClick={() => handleApprovedFarmer()}
              />

            </Box>
          </Box>

          {/* Tab Selection */}
          <Box sx={{ width: "max-content", pt: 2 }}>
            <Tabs value={activeTab}
              onChange={handleTabChange}
              className="custom-tabs"
              TabIndicatorProps={{ style: { display: "none" } }}
            >
              <Tab label={translations[language].personalDetails} />
              <Tab label={translations[language].locationDetails} />
              <Tab label={translations[language].farmingDetails} />
              <Tab label={translations[language].farmOwnershipDetails} />
              <Tab label={translations[language].accessToFinance} />
            </Tabs>
          </Box>
        </Box>

        {/* Dynamic Tab Content */}
        <div className="tab-content">
          {activeTab === 0 && <PersonalDetails selectedFarmer={selectedFarmer} />}
          {activeTab === 1 && <LocationDetails selectedFarmer={selectedFarmer} galleryIsOpen={galleryIsOpen} setGalleryIsOpen={setGalleryIsOpen} />}
          {activeTab === 2 && <FarmingDetails selectedFarmer={selectedFarmer} />}
          {activeTab === 3 && <FarmOwnershipDetails selectedFarmer={selectedFarmer} />}
          {activeTab === 4 && <AccessToFinance selectedFarmer={selectedFarmer} />}
        </div>

        <Dialog
          open={isRejectOpen}
          onClose={() => handleRejectClose()}
          maxWidth="xs"
          fullWidth
          disableScrollLock
          PaperProps={{
            sx: { borderRadius: "12px" },
          }}>
          <div className="assign-div">
            {" "}
            <div className="d-flex justify-content-around align-items-center">
              <h5
                className="p-3 mb-0"
                style={{ textAlign: "center", marginLeft: "118px" }}
              >
                {translations[language].reject}
              </h5>
              <img
                src={taskAssign.closeIcon}
                alt=""
                style={{
                  height: "30px",
                  width: "30px",
                  cursor: "pointer",
                  marginLeft: "95px",
                }}
                onClick={() => handleRejectClose()}
              />
            </div>
          </div>
          <DialogContent>
            <FormControl fullWidth className="mb-3">
              <InputLabel>{translations[language].selectFarmingDetails}</InputLabel>
              <Select
                label={translations[language].selectFarmingDetails}
                name="farmingDetails"
                value={selectedFarmerDetails}
                onChange={(e) => setSelectedFarmerDetails(e.target.value)}
              >

                <MenuItem value={12}>Personal Details</MenuItem>
                <MenuItem value={13}>Location Details</MenuItem>
                <MenuItem value={14}>Farming Details</MenuItem>
                <MenuItem value={15}>Farm Ownership Details</MenuItem>
                <MenuItem value={16}>Access to Finance</MenuItem>

              </Select>

            </FormControl>
            <TextField
              fullWidth
              id="outlined-multiline-static"
              label={translations[language].rejectDescription}
              name="rejectDescription"
              value={rejectDescription}
              onChange={(e) => {
                const inputValue = e.target.value;
                // Allow limit to 150 characters
                if (inputValue.length <= 150) {
                  setRejectDescription(inputValue);
                }
              }}
              multiline
              rows={3}
              className="textarea-taskDescription mb-3"
            />
            <Button
              title={translations[language].submit}
              classname={"assign-task-button"}
              onClick={() => handleRejectFarmer()}
              loading={loading}
            />


          </DialogContent>

        </Dialog>

      </Box>
      {/* </Grid>
      </Grid> */}
    </>
  );
};

export default PreviewFarmersDetails;
